module.exports = __webpack_public_path__ + "static/media/Codes_Scan.c73a016b.svg";